﻿'use strict';

angular.module('ntmApp').factory('RoomRackCensus', ['$timeout', '$location', '$routeParams', 'FlashService', 'TodaysAssignmentsService', 'Constants', 'UserInfo',
    function ($timeout, $location, $routeParams, FlashService, TodaysAssignmentsService, Constants, UserInfo) {

        function RoomRackCensus(todaysAssignments) {

            var self = this;
            var currentUser = null;

            self.rackCensusUpdatedStatusIcons = Constants.TodaysAssignments.RoomRackCensus.RackCensusUpdatedStatusIcons;

            UserInfo.GetUserInfo().then(function (user) {
                currentUser = user;
            });
			
			//TODO: add SignalR here

            self.LoadRoomRackCensus = function (dataChangedBySocket) {

                todaysAssignments.dataLoaded = dataChangedBySocket;
                FlashService.ShowProgressBar();

                self.rackCensusData = {
                    facilityCode: $routeParams.facilityId,
                    roomNumber: $routeParams.roomId
                };

                TodaysAssignmentsService.GetRoomRackCensus(self.rackCensusData).then(function (result) {
                    if (result.success) {
                        let rackCensusCutoffWeekday = parseInt(result.data.rackCensusCutoffWeekday);

                        self.rackCensusDataList = result.data.rackCensusDataList.groupBy('pkRack');

                        let censusCutoff = getCensusCutoff(rackCensusCutoffWeekday);

                        self.rackCensusDataList.forEach(function (rackCensusGroupDataItem) {
                            processRackCensusDataGroupingObjectPrimaryData(rackCensusGroupDataItem, censusCutoff);
                            processRackCensusDataGroupingObjectAdditionalData(rackCensusGroupDataItem, censusCutoff);
                        });

                        self.rackCensusDataListCopy = angular.copy(self.rackCensusDataList);

                        self.selectRackTab(0);

                        if (dataChangedBySocket) {
                            FlashService.Success("Your schedule has been updated");
                        }

                        FlashService.HideProgressBar();
                        todaysAssignments.dataLoaded = true;
                    }
                });
            };

            self.LoadRoomRackCensusButton = function (isDataChangedBySocket) {

                todaysAssignments.dataLoaded = isDataChangedBySocket;

                self.rackCensusData = {
                    facilityCode: $routeParams.facilityId,
                    roomNumber: $routeParams.roomId
                };

                TodaysAssignmentsService.GetRoomRackCensus(self.rackCensusData).then(function (result) {
                    if (result.success) {
                        let rackCensusCutoffWeekday = parseInt(result.data.rackCensusCutoffWeekday);

                        self.rackCensusDataList = result.data.rackCensusDataList.groupBy('pkRack');

                        let censusCutoff = getCensusCutoff(rackCensusCutoffWeekday);

                        self.rackCensusDataList.forEach(function (rackCensusGroupDataItem) {
                            processRackCensusDataGroupingObjectUpdatedStatusIconData(rackCensusGroupDataItem, censusCutoff);
                        });

                        if (todaysAssignments.isRoomGroupsLevel()) {
                            self.rackCensusButtonIcon = getRackCensusButtonIcon(self.rackCensusDataList);
                        }

                        todaysAssignments.dataLoaded = true;
                    }
                });
            };

            self.SaveRackCensus = function () {
                var data = {};
                data.pkRack = self.selectedRackTab.pkRack;
                data.totalCageCount = self.selectedRackTab.totalCageCount;
                data.rackItems = [];
                self.selectedRackTab.items.forEach(function (item) {
                    if (item.rackItemId) {
                        data.rackItems.push({ id: item.rackItemId, value: item.rackItemCount });
                    }
                });

                self.isRackValid = true;

                validateRackTab(self.selectedRackTab);

                if (!self.isRackValid) {
                    return;
                }

                var loading = FlashService.Loading();
                TodaysAssignmentsService.SaveRoomRackCensus(data).then(function (result) {
                    loading.dismiss();

                    if (result.success) {

                        self.selectedRackTab.rackLastInventoryPerson = currentUser.fullname;

                        self.selectedRackTab.rackLastInventoryDateFormattedDisplay = 'today';
                      
                        self.selectedRackTab.isIconChanging = true;

                        $timeout(function () {
                            self.selectedRackTab.groupUpdatedStatusIcon = self.rackCensusUpdatedStatusIcons.RecentlyUpdated;
                            self.selectedRackTab.updatedStatusIcon = self.rackCensusUpdatedStatusIcons.RecentlyUpdated;
                            self.selectedRackTab.isIconChanging = false;
                        }, 50);

                        self.selectedRackTab.items.forEach(item => {

                            item.rackItemLastInventoryPerson = currentUser.fullname;

                            item.rackItemLastInventoryDateFormattedDisplay = 'today';
                           
                            item.isIconChanging = true;

                            $timeout(function () {
                                item.updatedStatusIcon = self.rackCensusUpdatedStatusIcons.RecentlyUpdated;
                                item.isIconChanging = false;
                            }, 50);
                        });

                        self.rackCensusDataListCopy = angular.copy(self.rackCensusDataList);

                        FlashService.Success(result.data.message);
                    }
                });
            };

            self.ResetRackCensus = function () {
                self.rackCensusDataList.forEach(function (rack) {
                    var initialRack = self.rackCensusDataListCopy.filter(function (initialRack) { return initialRack.pkRack === rack.pkRack; })[0];

                    rack.totalCageCount = initialRack.totalCageCount;

                    rack.items.forEach(function (rackItem) {
                        var initialRackItem = initialRack.items.filter(function (initialRackItem) { return initialRackItem.rackItemId === rackItem.rackItemId; })[0];

                        rackItem.rackItemCount = initialRackItem.rackItemCount;
                    });
                });
            };

            self.selectRackTab = function (rackTabNumber) {
                setSelectedRackTabToFalse();

                if (self.rackCensusDataList && self.rackCensusDataList.length > 0 && rackTabNumber <= self.rackCensusDataList.length) {
                    self.rackCensusDataList[rackTabNumber].isSelected = true;
                    self.selectedRackTab = self.rackCensusDataList[rackTabNumber];
                }
            };

            self.isRoomRackCensusButtonShown = function () {
                return todaysAssignments.roomActivitiesGroups && todaysAssignments.roomActivitiesGroups.length && hasRoomRacks(todaysAssignments.roomActivitiesGroups);
            };

            function needRefresh(callback) {

                if (!moment().isSame(callback.date, 'day')) {
                    return false;
                }

                if (callback.draggedAssigneeId === currentUser.userId) {
                    return true;
                }

                return (self.rackCensusDataList || []).some(a =>
                    a.items.some(i => 
                        i.roomNumber === callback.dailySocketFacilities[0].roomNumber &&
                        i.facilityCode === callback.dailySocketFacilities[0].facilityCode
                ));
            }

            function processRackCensusDataGroupingObjectPrimaryData(rackCensusGroupDataItem, censusCutoff) {
                rackCensusGroupDataItem.pkRack = rackCensusGroupDataItem.items[0].pkRack;
                rackCensusGroupDataItem.rackId = rackCensusGroupDataItem.items[0].rackId;
                rackCensusGroupDataItem.speciesName = rackCensusGroupDataItem.items[0].speciesName;
                rackCensusGroupDataItem.totalCageCount = rackCensusGroupDataItem.items[0].totalCageCount;
                rackCensusGroupDataItem.rackLastInventoryDate = rackCensusGroupDataItem.items[0].rackLastInventoryDate;
                rackCensusGroupDataItem.rackLastInventoryDate = moment(rackCensusGroupDataItem.rackLastInventoryDate).startOf('day');
                rackCensusGroupDataItem.rackLastInventoryDateFormattedDisplay = getFormattedDateDiffDisplay(rackCensusGroupDataItem.rackLastInventoryDate);
                rackCensusGroupDataItem.rackLastInventoryPerson = rackCensusGroupDataItem.items[0].rackLastInventoryPerson;
                rackCensusGroupDataItem.updatedStatusIcon = getUpdatedStatusIcon(moment(rackCensusGroupDataItem.rackLastInventoryDate), censusCutoff.censusCutoffLastDate, censusCutoff.censusCutoffNextDate);
            }

            function processRackCensusDataGroupingObjectAdditionalData(rackCensusGroupDataItem, censusCutoff) {
                rackCensusGroupDataItem.items.forEach(rackCensusItem => {
                    rackCensusItem.rackItemLastInventoryDate = moment(rackCensusItem.rackItemLastInventoryDate).startOf('day');
                    rackCensusItem.rackItemLastInventoryDateFormattedDisplay = getFormattedDateDiffDisplay(rackCensusItem.rackItemLastInventoryDate);
                    rackCensusItem.updatedStatusIcon = getUpdatedStatusIcon(moment(rackCensusItem.rackItemLastInventoryDate), censusCutoff.censusCutoffLastDate, censusCutoff.censusCutoffNextDate);
                });

                rackCensusGroupDataItem.cageTypeToDisplay = rackCensusGroupDataItem.items[0].abbvCageType && rackCensusGroupDataItem.items[0].abbvCageType.length > 0 ? rackCensusGroupDataItem.items[0].abbvCageType : rackCensusGroupDataItem.items[0].cageType;
                rackCensusGroupDataItem.rackTypeToDisplay = rackCensusGroupDataItem.items[0].abbvRackType && rackCensusGroupDataItem.items[0].abbvRackType.length > 0 ? rackCensusGroupDataItem.items[0].abbvRackType : rackCensusGroupDataItem.items[0].rackType;
                rackCensusGroupDataItem.latestRackItemlastInventoryDate = getLatestRackCensusGroupLastInventoryDate(rackCensusGroupDataItem);
                rackCensusGroupDataItem.groupUpdatedStatusIcon = getUpdatedStatusIcon(moment(rackCensusGroupDataItem.latestRackItemlastInventoryDate), censusCutoff.censusCutoffLastDate, censusCutoff.censusCutoffNextDate);
            }

            function processRackCensusDataGroupingObjectUpdatedStatusIconData(rackCensusGroupDataItem, censusCutoff) {
                rackCensusGroupDataItem.items.forEach(rackCensusItem => {
                    rackCensusItem.rackItemLastInventoryDate = moment(rackCensusItem.rackItemLastInventoryDate).startOf('day');
                });
                rackCensusGroupDataItem.latestRackItemlastInventoryDate = getLatestRackCensusGroupLastInventoryDate(rackCensusGroupDataItem);
                rackCensusGroupDataItem.groupUpdatedStatusIcon = getUpdatedStatusIcon(moment(rackCensusGroupDataItem.latestRackItemlastInventoryDate), censusCutoff.censusCutoffLastDate, censusCutoff.censusCutoffNextDate);
            }

            function getCensusCutoff(rackCensusCutoffWeekday) {
                let censusCutoff = {
                    censusCutoffLastDate: null,
                    censusCutoffNextDate: null
                };

                let currentWeekDay = moment().day();

                if (currentWeekDay < rackCensusCutoffWeekday) {
                    censusCutoff.censusCutoffLastDate = moment().startOf('day').subtract(7, 'days').add(rackCensusCutoffWeekday - currentWeekDay, 'days');
                    censusCutoff.censusCutoffNextDate = moment().startOf('day').add(rackCensusCutoffWeekday - currentWeekDay, 'days');
                } else {
                    censusCutoff.censusCutoffLastDate = moment().startOf('day').subtract(currentWeekDay - rackCensusCutoffWeekday, 'days');
                    censusCutoff.censusCutoffNextDate = moment().startOf('day').add(7, 'days').subtract(currentWeekDay - rackCensusCutoffWeekday, 'days');
                }

                return censusCutoff;
            }

            function hasRoomRacks(rackActivityGroups) {
                return rackActivityGroups.some(function (rackItem) {
                    return rackItem.groupName !== 'Room Activities' && rackItem.groupName !== 'Cage Activities';
                });
            }

            function getFormattedDateDiffDisplay(dateToFormat) {
                if (moment(dateToFormat).isValid()) {
                    var receivedDate = moment(dateToFormat).startOf('day');
                    var todaysDate = moment().startOf('day');
                    var daysDiff = todaysDate.diff(receivedDate, 'days');

                    switch (daysDiff) {
                        case 0: return 'today';
                        case 1: return 'yesterday';
                        default: return daysDiff + ' days ago';
                    }
                }

                return null;
            }

            function validateRackTab(tabRackData) {
                var rackItemsValueSummaries = 0;

                var errorMessage = null;

                if (angular.isUndefined(tabRackData.totalCageCount) || tabRackData.totalCageCount === null) {
                    if (!errorMessage) {
                        errorMessage = 'Please, fill all required fields';
                    }
                    tabRackData.totalCageCountIsNotFilled = true;
                    self.isRackValid = false;
                } else {
                    tabRackData.totalCageCountIsNotFilled = false;
                }

                tabRackData.items.forEach(function (rack) {

                    if (rack.rackItemId) {

                        if (angular.isUndefined(rack.rackItemCount) || rack.rackItemCount === null) {
                            if (!errorMessage) {
                                errorMessage = 'Please, fill all required fields';
                            }
                            rack.rackItemCountIsNotFilled = true;
                            self.isRackValid = false;
                        } else {
                            rack.rackItemCountIsNotFilled = false;
                        }


                        if (rack.rackItemCount) {
                            rackItemsValueSummaries += rack.rackItemCount;
                        }
                    }
                });

                if (errorMessage) {
                    FlashService.Error(errorMessage);
                }
            }

            function getLatestRackCensusGroupLastInventoryDate(rackCensusGroupDataItem) {
                let rackItemlastInventoryDatesArray = [];

                rackItemlastInventoryDatesArray.push(moment(rackCensusGroupDataItem.items[0].rackLastInventoryDate));

                if (areThereRackItems(rackCensusGroupDataItem)) {
                    rackCensusGroupDataItem.items.forEach(rackCensusItem => {
                        rackItemlastInventoryDatesArray.push(moment(rackCensusItem.rackItemLastInventoryDate));
                    });
                }

                return moment.min(rackItemlastInventoryDatesArray);
            }

            function areThereRackItems(rackCensusGroupDataItem) {
                return rackCensusGroupDataItem.items.length > 1 || (rackCensusGroupDataItem.items.length === 1 && rackCensusGroupDataItem.items[0].rackItemId);
            }

            function getRackCensusButtonIcon(rackCensusDataList) {
                var updateUpcomingItemsList = [];
                var updateOverdueItemsList = [];
                var recentlyUpdatedItemsList = [];

                rackCensusDataList.forEach(function (rackCensusGroupDataItem) {
                    if (rackCensusGroupDataItem.groupUpdatedStatusIcon.icon === self.rackCensusUpdatedStatusIcons.UpdateUpcoming.icon) {
                        updateUpcomingItemsList.push(self.rackCensusUpdatedStatusIcons.UpdateUpcoming);
                    }
                    if (rackCensusGroupDataItem.groupUpdatedStatusIcon.icon === self.rackCensusUpdatedStatusIcons.UpdateOverdue.icon) {
                        updateOverdueItemsList.push(self.rackCensusUpdatedStatusIcons.UpdateUpcoming);
                    }
                    if (rackCensusGroupDataItem.groupUpdatedStatusIcon.icon === self.rackCensusUpdatedStatusIcons.RecentlyUpdated.icon) {
                        recentlyUpdatedItemsList.push(self.rackCensusUpdatedStatusIcons.UpdateUpcoming);
                    }
                });

                if (updateOverdueItemsList.length === 0 && updateUpcomingItemsList.length > 0) {
                    return self.rackCensusUpdatedStatusIcons.UpdateUpcoming;
                }

                if (updateOverdueItemsList.length > 0) {
                    return self.rackCensusUpdatedStatusIcons.UpdateOverdue;
                }

                if (recentlyUpdatedItemsList.length === rackCensusDataList.length) {
                    return self.rackCensusUpdatedStatusIcons.RecentlyUpdated;
                }

                return false;
            }

            function getUpdatedStatusIcon(lastInventoryDate, censusCutoffLastDate, censusCutoffNextDate) {

                if (!moment(lastInventoryDate).isValid()) {
                    return self.rackCensusUpdatedStatusIcons.UpdateOverdue;
                }

                if (moment(lastInventoryDate) < moment(censusCutoffLastDate).subtract(7, 'days')) {
                    return self.rackCensusUpdatedStatusIcons.UpdateOverdue;
                }
                if (moment(lastInventoryDate) >= moment(censusCutoffLastDate).subtract(7, 'days') && moment(lastInventoryDate) < moment(censusCutoffLastDate)) {
                    return self.rackCensusUpdatedStatusIcons.UpdateUpcoming;
                }
                if (moment(lastInventoryDate) >= moment(censusCutoffLastDate) && moment(lastInventoryDate) < moment(censusCutoffNextDate)) {
                    return self.rackCensusUpdatedStatusIcons.RecentlyUpdated;
                }

                return false;
            }

            function setSelectedRackTabToFalse() {
                if (self.rackCensusDataList && self.rackCensusDataList.length > 0) {
                    self.rackCensusDataList.forEach(function (rackCensusItem) {
                        rackCensusItem.isSelected = false;
                    });
                }
            }

            function initialize() {

            }

            initialize();
        }

        return (RoomRackCensus);
    }]);